import TipoCanalCombobox from "./TipoCanalCombobox.vue";

export {TipoCanalCombobox}
export default TipoCanalCombobox


